import { Component } from '@angular/core';

@Component({
  templateUrl: './check-user-R2-ok.component.html',
  styleUrls: ['./check-user-R2-ok.component.scss'],
})
export class CheckUserR2OkComponent {

  constructor() { }

}
